import { useKeycloak } from "@react-keycloak/web";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { userContext } from "../../Stores/Store";
import * as me_api from "../../Apis/Me_apis";
import * as contact_api from "../../Apis/Contacts_apis";
import { BsArrowRepeat } from "react-icons/bs";
import Loading from "../../Helpers/Loading";
import moment from "moment";

const ListCompsAndSkills = (props) => {
	const user = useContext(userContext);
	const setDiffDays = props.setDiffDays;

	const { keycloak, initialized } = useKeycloak();

	const [skills, setSkills] = useState();
	const [competitions, setCompetitions] = useState();
	const [loading, setLoading] = useState(false);

	// Initialisation des competitions
	useEffect(() => {
		const storedCompId = localStorage.getItem("competitionid");
		const storedSkillId = localStorage.getItem("skillid");
		setCompetitions(props.competitions && props.competitions);

		if (props.competitions && props.competitions.length > 0) {
			const hasStoredCompetition = storedCompId && props.competitions.some((c) => c.id == storedCompId);
			if (hasStoredCompetition) {
				user.setCompetitionid(storedCompId);
				if (storedSkillId) user.setSkillid(storedSkillId);
			} else {
				const fallbackCompId = props.competitions[props.competitions.length - 1].id;
				user.setCompetitionid(fallbackCompId);
				localStorage.setItem("competitionid", fallbackCompId);
				localStorage.removeItem("skillid");
			}
		}
	}, [
		props.competitions,
		localStorage.getItem("competitionid"),
		localStorage.getItem("skillid"),
	]);

	// Initialisation des métiers
	useEffect(() => {
		if (user.competitionid !== 0) {
			countDateStart();
			setLoading(true);
			me_api
				.getSkillsAsync(keycloak.token, user.competitionid)
				.then((res) => {
					setSkills(res);
					const storedSkillId = localStorage.getItem("skillid");
					const hasStoredSkill = storedSkillId && res && res.some((s) => s.number == storedSkillId);
					if (hasStoredSkill) {
						user.setSkillid(storedSkillId);
					} else if (res && res.length > 0) {
						const fallbackSkill = res[res.length - 1].number;
						user.setSkillid(fallbackSkill);
						localStorage.setItem("skillid", fallbackSkill);
					} else {
						user.setSkillid(0);
						localStorage.removeItem("skillid");
					}
				})
				.catch(() => {})
				.finally(() => setLoading(false));
		}
	}, [user.competitionid]);

	const countDateStart = () => {
		if (user.competitionid && competitions) {
			if (
				competitions.find((element) => element.id == user.competitionid)
					?.date_start
			) {
				let date1 = competitions.find(
					(element) => element.id == user.competitionid,
				).date_start;
				let date2 = moment(new Date()).format("YYYY-MM-DD");
				let difference = moment(date1).diff(date2, "days");
				if (difference > 0) {
					setDiffDays("⏱ J-" + difference);
				} else if (difference == 0) {
					setDiffDays("Jour J ! C'est parti 🏅💪");
				} else if (difference < 0 && difference > -5) {
					setDiffDays("Allez la Team, on est tous avec vous ! 🏅💪");
				} else {
					setDiffDays();
				}
			} else setDiffDays();
		}
	};

	useEffect(() => {
		countDateStart();
	}, [competitions]);

	// Initialisation des droits et liste des contacts
	useEffect(() => {
		if (user.competitionid !== 0 && user.skillid !== 0) {
			me_api
				.getRightsAsync(keycloak.token, user.competitionid, user.skillid)
				.then(
					(res) => user.setUserRights(res), // Probleme de context avec l'objet, solution : Serialisation
				)
				.catch(() => {});
			me_api
				.getRolesAsync(keycloak.token, user.competitionid, user.skillid)
				.then(
					(res) => user.setUserRoles(res), // Probleme de context avec l'objet, solution : Serialisation
				)
				.catch(() => {});
			contact_api
				.getContactsAsync(keycloak.token, user.competitionid, user.skillid)
				.then((res) => {
					user.setContactsSkill(res);
				})
				.catch(() => {})
				.finally(() => setLoading(false));
		}
	}, [user.skillid, user.competitionid]);

	const handleChange = (event) => {
		switch (event.target.name) {
			case "skill_select":
				user.setSkillid(event.target.value);
				localStorage.setItem("skillid", event.target.value);
				break;
			case "competition_select":
				user.setCompetitionid(event.target.value);
				localStorage.setItem("competitionid", event.target.value);
				localStorage.removeItem("skillid");
				break;
			default:
				break;
		}
	};

	const listCompetitions = () => {
		return competitions
			.sort((a, b) => (a.name > b.name ? 1 : -1))
			.map((competition) => {
				if (!localStorage.getItem("competitionid") || competitions.filter((element) => element.id == localStorage.getItem("competitionid")).length == 0) {
					localStorage.setItem("competitionid", competition.id);
				}
				return (
						<option
							value={competition.id}
						>
						{competition.name}
					</option>
				);
			});
	};

	const listSkills = () => {
		if (skills) {
			return skills
				.sort((a, b) => (a.name > b.name ? 1 : -1))
				.map((skill) => {
					if (!localStorage.getItem("skillid") || skills.filter((element) => element.number == localStorage.getItem("skillid")).length == 0) {
						localStorage.setItem("skillid", skill.number);
					}
					return (
						<option value={skill.number}>
							{skill.number + " - " + skill.name}
						</option>
					);
				});
		}
	};

	const reloadLists = () => {
		setLoading(true);
		me_api
			.getCompetitionsAsync(keycloak.token)
			.then((res) => {
				if (localStorage.getItem("competitionid")) {
					// Pour le refresh on stock l'id de competition dans un sessionStorage
					user.setCompetitionid(localStorage.getItem("competitionid"));
				} else {
					user.setCompetitionid(res[res.length - 1].id);
				}
				setCompetitions(res);
			})
			.then(() => setLoading(false));
	};

	//Contrôle du chargement des données
	if (loading) return <Loading />;

	return (
		<>
			<Col sm={3}>
				<Form.Select
					name="competition_select"
					size="sm"
					value={user.competitionid}
					onChange={handleChange}
				>
					{competitions && listCompetitions()}
				</Form.Select>
			</Col>
			<Col sm={3}>
				<Form.Select
					size="sm"
					name="skill_select"
					value={user.skillid}
					onChange={handleChange}
				>
					{skills && listSkills()}
				</Form.Select>
			</Col>
			<Col sm={3}>
				<Button
					size="sm"
					variant="outline-primary"
					onClick={() => reloadLists()}
				>
					<BsArrowRepeat />
				</Button>
			</Col>
		</>
	);
};

export default ListCompsAndSkills;
